module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "650px"
    }
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label marg-05-bottom"
  }, [_vm._v("Vælg medarbejder")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theSelectedUserId),
      expression: "theSelectedUserId"
    }],
    staticClass: "do-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.theSelectedUserId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onUserIsSelected]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Vælg person")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('option', {
      key: user.id,
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n        " + _vm._s(user.name) + "\n      ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Indtast første og sidste arbejdsdag for personen (begge dage inklusiv)")]), _vm._v(" "), _c('div', {
    staticClass: "d-group-flex"
  }, [_c('DatePickerRange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": function($event) {
        return _vm.setEndDate($event, true)
      }
    }
  }), _vm._v(" "), (!_vm.isDatesPristine) ? _c('p', {
    staticClass: "d-link",
    on: {
      "click": _vm.resetDates
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Antal feriedage afholdt i perioden")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numberOfVacationDays),
      expression: "numberOfVacationDays"
    }],
    staticClass: "d-input__number",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.numberOfVacationDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numberOfVacationDays = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Timer pr. uge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hoursPerWeek),
      expression: "hoursPerWeek"
    }],
    staticClass: "d-input__number",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.hoursPerWeek)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hoursPerWeek = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Udregning")]), _vm._v(" "), _c('table', {
    staticClass: "do-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Antal dage")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDays))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Antal dage uden weekender")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekends))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekendsInHours))])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom',
        onShow: function () { return _vm.hasAnyHolidays; }
      }),
      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  onShow: () => hasAnyHolidays\n                }"
    }],
    attrs: {
      "content": _vm.holidaysAsLabels
    }
  }, [_c('td', [_vm._v("Antal søgnehellidage på hverdage")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filteredHolidays.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filteredHolidaysInHours))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Antal arbejdsdage fratrukket søgnehellidage")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekendsAndHolidays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfDaysWithoutWeekendsAndHolidaysInHours))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ferie afholdt")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfVacationDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfVacationDaysInHours))])]), _vm._v(" "), _c('tr', {
    staticClass: "d-diff"
  }, [_c('td', [_vm._v("Mulig arbejdstid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfWorkDaysPossible))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberOfWorkDaysPossibleInHours))])]), _vm._v(" "), (_vm.userData) ? [_c('tr', {
    staticClass: "d-diff"
  }, [_vm._m(1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userActualHours))])]), _vm._v(" "), (_vm.userData) ? _c('tr', {
    staticClass: "d-diff"
  }, [_c('td', [_vm._v("Difference i arbejdstid")]), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.userActualHoursDiff) ? _c('td', [_vm._v(_vm._s(_vm.userActualHoursDiff > 0 ? '+' : '') + _vm._s(_vm.userActualHoursDiff))]) : _vm._e()]) : _vm._e()] : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("For perioden")]), _vm._v(" "), _c('th', [_vm._v("Dage")]), _vm._v(" "), _c('th', [_vm._v("Timer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Præsteret arbejdstid")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e2b81218!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursEmploymentEnded.vue
// module id = 2147
// module chunks = 1